import Page from 'src/features/transfers/components/TransferReceive/Page/Page'
import UserIdentifier from 'src/features/transfers/components/TransferReceive/UserIdentifier/UserIdentifier'
import WaitingInfo from 'src/features/transfers/components/WaitingInfo/WaitingInfo'

const ReceiveWaiting = () => (
  <Page headerTitle='Receber Transferência'>
    <UserIdentifier />
    <WaitingInfo />
  </Page>
)

export default ReceiveWaiting
